import * as base64 from "base64-js";

import type { Expression } from "./expressions/index.ts";
import { ByteReader, parseStored, stripExpression } from "./storedFormat/index.ts";

/**
 * Generate an Expression tree for evaluating keyword searches
 * @param compiled
 */
export const parseExpression = (compiled: string): Expression => {
  const expression = parseStored(new ByteReader(base64.toByteArray(compiled)));
  return stripExpression(expression);
};
